<button
    class="rounded-md border-2 bg-primary-100 w-full h-[120px] flex items-center gap-4 mt-2 min-w-[320px] text-start"
    [ngClass]="selectedOption === 'upload' ? 'border-primary' : 'border-border'" (click)="selectOption('upload')">
    <img src="assets/icons/onboarding/file.svg" width="80px" height="80px" class="ml-4"
        alt="{{ 'shared.file_icon' | transloco }}" />
    <div class="flex flex-col">
        <p class="font-bold">{{ 'auth.upload_show_choice.upload_your_invoice' | transloco }}</p>
        <p class="text-sm text-neutral-500">
            {{ 'auth.upload_show_choice.neox_will_extract_information' | transloco }}
        </p>
    </div>
</button>

<button
    class="rounded-md border-2 bg-primary-100 w-full h-[120px] flex items-center gap-4 mt-2 min-w-[320px] text-start"
    [ngClass]="selectedOption === 'show' ? 'border-primary' : 'border-border'" (click)="selectOption('show')">
    <img src="assets/icons/onboarding/show.svg" width="80px" height="80px" class="ml-4" />
    <div class="flex flex-col">
        <p class="font-bold">{{ 'auth.upload_show_choice.show_me_dashboard' | transloco }}</p>
        <p class="text-sm text-neutral-500">
            {{ 'auth.upload_show_choice.we_provide_sample_data' | transloco }}
        </p>
    </div>
</button>